import React from 'react';
import Button from '../molecules/Button';
import { FTUEStep } from '../../types/ftue.types';
import './FTUETextBox.scss';

interface FTUETextBoxProps {
  step: FTUEStep;
  onClose: () => void;
  position?: {
    top?: number;
    left?: number;
    right?: number;
    bottom?: number;
  };
  isLastStep?: boolean;
}

export const FTUETextBox: React.FC<FTUETextBoxProps> = ({
  step,
  onClose,
  position,
  isLastStep = false,
}) => {
  const textBoxStyle: React.CSSProperties = {
    position: 'absolute',
    zIndex: 10001, // Higher than overlay
    ...position,
  };

  return (
    <div className="ftue-textbox" style={textBoxStyle}>
      <div className="ftue-textbox__content">
        <div className="ftue-textbox__header">
          <h3 className="ftue-textbox__title">{step.title}</h3>
        </div>
        <div className="ftue-textbox__body">
          <p className="ftue-textbox__text">{step.content}</p>
        </div>
        <div className="ftue-textbox__footer">
          <Button
            onClick={onClose}
            small
            className="ftue-textbox__close-btn"
          >
            {isLastStep ? 'Finish' : 'Next'}
          </Button>
        </div>
      </div>
    </div>
  );
};
